
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { VtLink } from './components.js';

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <Stack direction="column"
        sx={{
          width: '100%',
          height: '100%',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
      <Stack direction="column" spacing={1} sx={{ alignItems: 'center' }}>
        <Box>
          {error
              ? error.message
              : 'Something went wrong!'}
        </Box>
        {resetErrorBoundary && <Box><VtLink onClick={resetErrorBoundary}>Try again</VtLink></Box>}
        <Box><VtLink href="#/">Back to VoiceTopics</VtLink></Box>
      </Stack>
    </Stack>
  );
};

export default ErrorFallback;
